import React, { forwardRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import classNames from 'classnames';
import { selectisFotofunPanelOpen, setisFotofunPanelOpen, setFotoFunTab, selectFotoFunTab } from '../../_redux-ui';
import { MainContent } from './MainContent';
import { OptionContent } from './OptionContent';
import styles from './FotofunPanel.module.scss';

export const FotofunPanel = forwardRef<HTMLDivElement>((_, ref) => {

    const dispatch = useDispatch();

    const [hasOpenedFotofunPanel, setHasOpenedFotofunPanel] = useState(false);

    const isFotofunPanelOpen = useSelector(selectisFotofunPanelOpen);
    const fotoFunTab = useSelector(selectFotoFunTab);

    const toggleFotofunPanel = () => {
        dispatch(setisFotofunPanelOpen(!isFotofunPanelOpen));
    };

    const setPanelContentTab = (tab: 'main' | 'magical' | 'standard' | 'accessories') => {
        dispatch(setFotoFunTab(tab));
    };

    useEffect(() => {
        if (isFotofunPanelOpen && !hasOpenedFotofunPanel) {
            setHasOpenedFotofunPanel(true);
        }
    }, [isFotofunPanelOpen, hasOpenedFotofunPanel]);

    const contentClassName = classNames(styles.content, {
        [styles.mainActive]: fotoFunTab === 'main',
        [styles.magicalActive]: fotoFunTab === 'magical',
        [styles.standardActive]: fotoFunTab === 'standard',
        [styles.accessoriesActive]: fotoFunTab === 'accessories'
    });

    const handleClassName = classNames(styles.handle, {
        [styles.active]: isFotofunPanelOpen,
        [styles.activeOption]: isFotofunPanelOpen && fotoFunTab !== 'main'
    });

    const fotofunPanelClassName = classNames(styles.fotofunPanel, {
        [styles.active]: isFotofunPanelOpen,
        [styles.activeOption]: isFotofunPanelOpen && fotoFunTab !== 'main'
    });


    return (
        <div ref={ref} className={fotofunPanelClassName}>

            <div className={styles.contentOverflow}>
                <div className={contentClassName}>
                    <MainContent
                        setPanelContentTab={setPanelContentTab}
                />
                <OptionContent setPanelContentTab={setPanelContentTab} />
                </div>
            </div>

            <div className={handleClassName} onClick={toggleFotofunPanel}>
                <Icon className={styles.icon} type='general-ui-chevron-left' strokeWidth={2} />
            </div>
        </div>
    );
});